import React from 'react'
import { Link } from 'react-router-dom'
import Rabi from './../../assets/img/kharif-pic2.jpg';
import kharif from './../../assets/img/rabi-pic2.jpg';
const Vegetables = () => {
  return (
    <div className="container my-3">

    <div className="abouts">
        <h5>Vegetables</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>
<p>Haryana Seeds Development Corporation Ltd. is the sole Govt. Undertaking in Haryana engaged in production, processing and marketing of cereals / fodder / oil seeds / pulses and vegetable quality seeds. Generally, following improved vegetable seeds:</p>
        <div className="row  justify-content-between">
            
            <div className="col-lg-6  text-center">

                <img src={Rabi} alt="Seed Production" className="img-fluid rounded shadow-sm" />
              <Link to={"/products/vegetables/rabi-crops-Vegetables"} style={{color:'green',textDecoration:'none'}} >  
              <h5 className='mt-2'>Rabi Season</h5>
                <p>Peas, Carrot, Palak, Methi, Radish, Turnip, Coriander, Onion, Tomato, Bitter Gourd, Capsicum, Potato...</p>
                </Link>
            </div>
            <div className="col-lg-6   text-center">
                <img src={kharif} alt="Seed Production" className="img-fluid rounded shadow-sm" />
                <Link to={"/products/vegetables/kharif-crops-Vegetables"} style={{color:'green',textDecoration:'none'}}>  
                <h5 className='mt-2'>Kharif Season</h5>
                <p>Muskmelon, Bhindi, Tinda, Bottle Gourd, Sponge Gourd, Bitter Gourd, Cucumber, Brinjal, Chillies, Tomato...</p>
                </Link>
            </div>

        </div>
<p>The Breeder / Foundation seeds of vegetable crops are being provided to the seed growers under Seed Production Program by HSDC and the Certified / TL seeds are being sold to the farmers on general sale rates, being very reasonable rates through the network of 74-outlets of HSDC in the State. It caters to the need of farmers at their door step. The inclusion of good quality vegetable seeds in large quantities through HSDC's sale network is very beneficial to the farmers of the State.</p>
        <Link to={"/schemes"} style={{color:'green',textDecoration:'none'}}> <p className='text-center'>Schemes</p></Link>
        </div>
    </div>
  )
}

export default Vegetables
